import pausedSubLogoRebranding from 'img/subscriptions/pause-subscription-logo-rebranding.png';
import { type BillingDataPlatform, BillingDataPartner } from 'reactApp/api/billing/data/BillingDataAPICall.types';
import { getPromoIcon } from 'reactApp/modules/billingData/billingData.links';
import { type BillingDataSubscriptionInfo, BillingDataSubscriptionInfoStatus } from 'reactApp/modules/billingData/billingData.types';
import { cheapestProductIDs } from 'reactApp/modules/products/products.const';
import { EPromoSubscriptionType } from 'reactApp/modules/promoTariffs/promoTariffs.types';
import { isGraceSubscription, isVkMusicSubscription } from 'reactApp/sections/SubscriptionsPage/SubscriptionsPage.helpers';
import type { Product } from 'reactApp/types/Billing';
import { formatDefaultDate, formatFileHistoryDate } from 'reactApp/utils/formatDate';
import { getPeriodName } from 'reactApp/utils/Period';

export const getDescription = ({
    expires,
    autorenewal,
    renewAt,
    status,
    paused,
    isGrace,
}: {
    expires?: number;
    autorenewal?: boolean;
    renewAt?: number;
    status?: string;
    paused?: boolean;
    isGrace?: boolean;
}) => {
    if (paused && renewAt) {
        return `Оплата на паузе до ${formatFileHistoryDate(renewAt)}`;
    }

    if (status === BillingDataSubscriptionInfoStatus.FINISHED) {
        return 'Завершена';
    }

    if (autorenewal && renewAt && !isGrace) {
        return `Списание ${formatDefaultDate(renewAt)}`;
    } else if (expires) {
        return `Действует до ${formatDefaultDate(expires)}`;
    }

    return 'Подключено';
};

export const composeContent = ({
    subscription,
    product,
    pausedSubscription,
}: {
    subscription: BillingDataSubscriptionInfo;
    product?: Product;
    pausedSubscription: boolean;
}) => {
    const { autorenewal, renewAt, expires, isTrial, space, partner, status } = subscription;
    const isGrace = isGraceSubscription(subscription);
    const period = (isTrial && !product?.isForceDiscountTrial && product?.trialPeriod) || product?.period;
    const periodText = period ? ` на ${getPeriodName(period, false, true)}` : '';
    const subscriptionType = subscription.type as EPromoSubscriptionType | BillingDataPlatform;
    const showWaiting = [BillingDataSubscriptionInfoStatus.FINISHED, BillingDataSubscriptionInfoStatus.SUSPENDED].includes(
        status as BillingDataSubscriptionInfoStatus
    );

    let title = `${space.value}${periodText}`;
    let icon = subscription.icon;

    if (subscriptionType === EPromoSubscriptionType.quota) {
        title = `Подарок ${space.value}${periodText}`;
        // tempexp_16598-next-line
    } else if (product?.id && Object.values(cheapestProductIDs).includes(product.id)) {
        title = 'Тариф: Без рекламы';
    }

    if (isVkMusicSubscription(subscription)) {
        title = `${space.value} и VK Музыка${periodText}`;
        icon = getPromoIcon(BillingDataPartner.vkmusic);
    }

    return {
        title,
        description: getDescription({
            autorenewal,
            expires,
            renewAt,
            status,
            isGrace,
            paused: pausedSubscription,
        }),
        icon: pausedSubscription ? pausedSubLogoRebranding : icon,
        partner,
        showWaiting,
    };
};
